<script setup lang="ts">
import { computed } from 'vue'
import MultiSelectDropdown from '@/components/MultiSelectDropdown.vue'
import { sortGrades } from '@/browse/grades'

const props = withDefaults(defineProps<{
  options: string[]
  selected: string[]
  disabled?: boolean
}>(), {
  disabled: false
})

const emit = defineEmits<{ 'update:selected': [grades: string[]] }>()

const gradeOptions = computed(() => props.options.map(grade => ({ label: grade, value: grade })))
</script>

<template>
  <div class="mb-4">
    <label for="grades-select" class="block mb-1 font-bold">Grades</label>
    <MultiSelectDropdown
      id="grades-select"
      :options="gradeOptions"
      :model-value="selected"
      :disabled="disabled"
      @update:model-value="grades => emit('update:selected', sortGrades(grades))"
    />
  </div>
</template>
